<template>
    <v-container fluid class="pa-6">
        <div class="headline font-weight-bold pb-4">
            {{ $t('menu.teamBuilding.customer') }}
        </div>

        <customer-group-list-view
            class="customer-group-list-view"
            :customerGroups="customerGroups"
            :pagination="pagination"
        />

        <v-pagination
            class="pt-2"
            :style="{
                marginRight: '-8px'
            }"
            :value="pagination.page"
            :length="pagination.pageTotal"
            :total-visible="pagination.pageTotal"
            @input="onPaginationChanged"
        />
    </v-container>
</template>

<script>
import CustomerGroupListView from '@/views/CustomerGroupListView'
import { getCustomerGroupList } from '@/services/mock'

export default {
    name: 'CustomerGroupListPage',

    components: {
        CustomerGroupListView
    },

    data () {
        return {
            customerGroups: [],
            pagination: {
                page: 1,
                pageTotal: 1,
                pageTotalVisible: 6,
                itemsPerPage: 50
            }
        }
    },

    mounted () {
        this.getMockData()
    },

    methods: {
        getMockData () {
            this.customerGroups = getCustomerGroupList()
        },

        onPaginationChanged () {}
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-pagination {
    justify-content: right;
    margin-right: -12px;
}
</style>
